module.exports = __webpack_public_path__ + "img/head_select.069e0883.svg";